import React, { useEffect, useState } from 'react';
import Header from '../components/Header';
import { Grid } from '@material-ui/core';
import DoctariCalendar from '../components/DoctariCalendar';
import MonthCalendar from '../components/MonthCalendar';
import DateControl from '../components/DoctariCalendar/DateControl';
import DoctariSpinner from '../components/Spinner';
import { getSchedules } from '../config/apiConfig';
import moment from 'moment';

function ExamsCalendar() {
  const [appointmentType, setAppointmentType] = useState('');
  const [openAppointmentTypeModal, setOpenAppointmentTypeModal] =
    useState(false);
  const [loading, setLoading] = useState(true);
  const [dateHandler, setDateHandler] = useState({
    currentWeek: 0,
    currentMonth: 0,
    showByWeek: true,
  });
  const { currentWeek, currentMonth, showByWeek } = dateHandler;
  const [availability, setAvailability] = useState({
    start: null,
    end: null,
    isEditable: false,
    createModalOpen: false,
    openModalAvailability: false,
  });
  const [schedules, setSchedules] = useState({});
  const [isSemmMember, setSemmMember] = useState(
    JSON.parse(localStorage.getItem('isSemmMember'))
  );

  useEffect(() => {
    let date_start = moment()
      .add(currentWeek * 7, 'days')
      .startOf('week')
      .format('DD/MM/YYYY');
    let date_end = moment()
      .add(currentWeek * 7, 'days')
      .endOf('week')
      .format('DD/MM/YYYY');
    getSchedules(date_start, date_end, isSemmMember).then((res) => {
      setSchedules(res.data);
      setLoading(false);
    });
  }, [currentWeek]);

  return (
    <>
      {loading && (
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          style={{ height: '100vh', position: 'absolute', zIndex: 1000 }}
        >
          <DoctariSpinner />
        </Grid>
      )}

      {/* <DoctariModal
        title="Crear cita"
        open={openAppointmentTypeModal}
        setOpen={setOpenAppointmentTypeModal}
        justifyButtons="flex-end"
        primaryButton={{
          label: 'Aceptar',
          handleAction: () => {
            // handleUploadAttachments();
            console.log('hola');
          },
        }}
      >
        <Grid container direction="column">
          <Grid item xs={12}>
            <Autocomplete
              disablePortal
              id="combo-box-demo"
              options={['Medicina', 'Peritaje']}
              // getOptionLabel={(option) => option.name || ''}

              size="small"
              onChange={(event, value) => setAppointmentType(value)}
              value={appointmentType}
              renderInput={(params) => (
                <TextField {...params} label="Seleccione tipo de exámen" />
              )}
            />
          </Grid>
        </Grid>
      </DoctariModal> */}
      <div style={{ opacity: loading ? '0.4' : '1' }}>
        <Header />
        <Grid
          container
          direction="column"
          // spacing={3}
          style={{ padding: '0 30px' }}
        >
          <Grid container direction="column" item>
            <Grid container item justifyContent="center" alignItems="center">
              <span
                style={{
                  marginRight: '0.5rem',
                  cursor: 'pointer',
                  fontWeight: showByWeek ? 700 : 200,
                  fontSize: '24px',
                }}
                onClick={() =>
                  setDateHandler({
                    ...dateHandler,
                    showByWeek: true,
                    currentMonth: 0,
                  })
                }
              >{`Semana`}</span>
              {/* <span
            style={{
              fontSize: '34px',
              fontWeight: 200,
            }}
          >
            |
          </span>
          <span
            style={{
              marginLeft: '0.5rem',
              cursor: 'pointer',
              fontWeight: showByWeek ? 200 : 700,
            }}
            onClick={() =>
              setDateHandler({
                ...dateHandler,
                showByWeek: false,
                currentWeek: 0,
              })
            }
          >{` Mes`}</span> */}
            </Grid>
            <Grid container item justifyContent="center" alignItems="center">
              <DateControl
                showingByWeek={showByWeek}
                setCurrentWeek={(week) =>
                  setDateHandler({ ...dateHandler, currentWeek: week })
                }
                currentWeek={currentWeek}
                setCurrentMonth={(month) =>
                  setDateHandler({ ...dateHandler, currentMonth: month })
                }
                currentMonth={currentMonth}
              />
            </Grid>
            <Grid item style={{ width: '100%' }}>
              {!showByWeek ? (
                <MonthCalendar
                  currMonth={currentMonth}
                  // classes={classes}
                  goToWeek={(week) =>
                    setDateHandler({
                      ...dateHandler,
                      currentWeek: week,
                      currentMonth: 0,
                      showByWeek: true,
                    })
                  }
                />
              ) : (
                <DoctariCalendar
                  schedules={schedules}
                  currentWeek={currentWeek}
                  creatingAvailability
                  availability={availability}
                  setAvailability={setAvailability}
                  slot={15}
                />
              )}
            </Grid>
          </Grid>
        </Grid>
      </div>
    </>
  );
}

export default ExamsCalendar;
